import React from 'react';

export const IconPhotoshop: React.FC<React.SVGAttributes<SVGElement>> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 234">
    <path d="M10 10h220v214H10V10z" fill="#001d26" />
    <path
      d="M0 0v234h240V0H0zm10 10h220v214H10V10zm48 44.8c0-.7 1.4-1.2 2.2-1.2 6.4-.3 15.9-.5 25.8-.5 27.7 0 38.5 15.2 38.5 34.7 0 25.4-18.4 36.3-41 36.3l-7.8-.2v38.4c0 .8-.3 1.2-1.2 1.2H59.2c-.8 0-1.2-.3-1.2-1.2V54.8zm17.8 53.1c2.3.2 4.1.2 8.1.2 11.7 0 22.7-4.1 22.7-20 0-12.7-7.9-19.1-21.2-19.1-4 0-7.8.2-9.6.3v38.6zm86-11.9c-7.9 0-10.6 4-10.6 7.3 0 3.6 1.8 6.1 12.4 11.6 15.7 7.6 20.6 14.9 20.6 25.6 0 16-12.2 24.6-28.7 24.6-8.7 0-16.2-1.8-20.5-4.3-.7-.3-.8-.8-.8-1.6v-14.7c0-1 .5-1.3 1.2-.8a37.1 37.1 0 0020.1 5.9c7.9 0 11.2-3.3 11.2-7.8 0-3.6-2.3-6.8-12.4-12-14.2-6.8-20.1-13.7-20.1-25.2 0-12.9 10.1-23.6 27.6-23.6a46 46 0 0117.9 2.8c.8.5 1 1.3 1 2v13.7c0 .8-.5 1.3-1.5 1a33.8 33.8 0 00-17.4-4.5z"
      fill="#00c8ff"
    />
  </svg>
);
